import { jsonToInputParams } from 'library/util/graph';
import DataQuery from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';

const acceptRecommendedOutcomeMutation = async ({
  uuid,
  outcomeId,
  included_goal_ids,
}) => {
  const params = {
    uuid: uuid,
    outcome_id: outcomeId,
    included_goal_ids,
  };
  return await DataQuery(`
  mutation {
    accept_recommended_outcome(
      ${jsonToInputParams(params)}
    ) {
      success
      errors
    }
  }`);
};

const acceptRecommendedOutcomeMutationParseQuery = (data) => ({
  errors: resolve(data, 'accept_recommended_outcome/errors', []),
  success: resolve(data, 'accept_recommended_outcome/success', false),
});

export {
  acceptRecommendedOutcomeMutation,
  acceptRecommendedOutcomeMutationParseQuery,
};
